const path = 'leaveWarn/';
const RESET_LEAVE_WARN = `${path}RESET_LEAVE_WARN`;
const SET_LEAVE_WARN = `${path}SET_LEAVE_WARN`;
const ENABLE_UNLOAD_IGNORE = `${path}ENABLE_UNLOAD_IGNORE`;
const DISABLE_UNLOAD_IGNORE = `${path}DISABLE_UNLOAD_IGNORE`;

const initialState = {
  handler: null,
  ignoreUnload: false,
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_LEAVE_WARN:
      return Object.assign({}, state, {
        handler: action.payload.handler,
      });
    case RESET_LEAVE_WARN:
      return initialState;
    case ENABLE_UNLOAD_IGNORE:
      return Object.assign({}, state, {
        ignoreUnload: true,
      });
    case DISABLE_UNLOAD_IGNORE:
      return Object.assign({}, state, {
        ignoreUnload: false,
      });
    default:
      return state;
  }
}

// 設定leave warn視窗事件
export function setLeaveWarn(handler) {
  return {
    type: SET_LEAVE_WARN,
    payload: {
      handler,
    },
  };
}
export function resetLeaveWarn() {
  return {
    type: RESET_LEAVE_WARN,
  };
}

// 不在beforeunload顯示視窗
export function enableUnloadIgnore() {
  return {
    type: ENABLE_UNLOAD_IGNORE,
  };
}
export function disableUnloadIgnore() {
  return {
    type: DISABLE_UNLOAD_IGNORE,
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/LeaveWarn/reducer.js
 **/